import React from "react";

const SatsangTodo = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-3">Daily Satsang To-Do</h1>
      <p className="text-base">
        Track and manage your daily Satsang practices like Prarthna, Swadhyay, Bhajan, and Seva.
      </p>
    </div>
  );
};

export default SatsangTodo;
